// Anker-Offset: schreibt die Unterkante des sticky Headers (#bfw-header, Höhe plus
// sticky top – ab lg klebt er unter #meta; je Breakpoint unterschiedlich) in die
// CSS-Variable --bfw-header-height auf <html>.
// html { scroll-padding-top } in _basics.scss nutzt sie, damit Sprungziele
// (#c123, RTE-Anker, Berufsbild-Abschnitte, A–Z-Register) nicht unter dem Header landen.
export function initAnchorOffset() {
  const header = document.getElementById('bfw-header');
  if (!header) return;

  const root = document.documentElement;
  const update = () => {
    const top = parseFloat(getComputedStyle(header).top) || 0;
    root.style.setProperty('--bfw-header-height', `${header.offsetHeight + top}px`);
  };

  update();
  new ResizeObserver(update).observe(header);

  // Beim Seitenaufruf mit #anker hat der Browser bereits gesprungen, bevor die
  // Variable gesetzt war (Fallback-Offset) – einmal mit dem echten Offset nachziehen.
  if (window.location.hash.length > 1) {
    let target = null;
    try {
      target = document.getElementById(decodeURIComponent(window.location.hash.slice(1)));
    } catch (e) {
      // ungültig kodierter Hash – nichts tun
    }
    if (target) {
      target.scrollIntoView({ behavior: 'instant', block: 'start' });
    }
  }
}
